import { Bar, BarChart, CartesianGrid, Cell, Legend, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";

const GRID = "#eee9dc";
const PALETTE = ["#3a7a21", "#4B9B2B", "#6BC839", "#8ed966", "#b3e69a", "#d3f0c2", "#e8f5db", "#c8c2ad"];
const eur = (v: number) => "€" + v.toLocaleString("it-IT");

export type RankDatum = { label: string; value: number; meta?: string };

export function RankBar({ data, height = 256, currency = true, name = "Valore" }: {
  data: RankDatum[]; height?: number; currency?: boolean; name?: string;
}) {
  if (data.length === 0) {
    return (
      <div style={{ height }} className="flex items-center justify-center text-sm text-muted-foreground">
        Nessun dato disponibile.
      </div>
    );
  }
  return (
    <div style={{ height }}>
      <ResponsiveContainer width="100%" height="100%">
        <BarChart data={data} layout="vertical" margin={{ top: 4, right: 12, left: 8, bottom: 0 }}>
          <CartesianGrid strokeDasharray="3 3" stroke={GRID} horizontal={false} />
          <XAxis type="number" tickFormatter={currency ? eur : undefined} tick={{ fontSize: 11 }} />
          <YAxis type="category" dataKey="label" width={120} tick={{ fontSize: 11 }} />
          <Tooltip formatter={(v: number) => (currency ? eur(v) : v)} />
          <Legend wrapperStyle={{ fontSize: 11 }} />
          <Bar dataKey="value" name={name} radius={[0, 4, 4, 0]}>
            {data.map((_, i) => <Cell key={i} fill={PALETTE[i % PALETTE.length]} />)}
          </Bar>
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
}
